import React, { FC }                 from "react";
import { useDispatch, useStore }     from "react-redux";
import { Form, Input }               from "semantic-ui-react";
import RecordTemplate                from "../../../../domain/record/template/RecordTemplate";
import RecordTemplateName            from "../../../../domain/record/template/RecordTemplateName";
import RecordTemplateRepository      from "../../../../domain/record/template/RecordTemplateRepository";
import RecordTemplateDataSource
                                     from "../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import TopSection                    from "../../common/layout/TopSection";
import WidgetCarousel                from "../widget/carousel/WidgetCarousel";
import RecordTemplateDefaultSelector from "./RecordTemplateDefaultSelector";
import RecordTemplateDropArea        from "./RecordTemplateDropArea";

const RecordTemplateForm: FC = () => {
  const repository: RecordTemplateRepository = new RecordTemplateDataSource(useDispatch());
  const template: RecordTemplate = useStore().getState().template;
  return (
    <>
      <TopSection>
        <Form>
          <Form.Field>
            <RecordTemplateDefaultSelector/>
          </Form.Field>
          <Form.Field>
            <label>記録テンプレート名</label>
            <Input
              value={ template.name.value }
              onChange={ (event, data) => repository.setTemplateName(new RecordTemplateName(data.value)) }
            />
          </Form.Field>
        </Form>
      </TopSection>
      <WidgetCarousel/>
      <RecordTemplateDropArea/>
      <WidgetCarousel/>
    </>
  );
};

export default RecordTemplateForm;
